const findAttributeValueById = (attributeValueGroups, id) => attributeValueGroups
	.reduce((accum, curr) => [ ...curr.AttributeValues, ...accum ], [])
	.find((attrVal) => attrVal.AttributeValueId === window.parseInt(id, 10));

export default findAttributeValueById;
